"use strict";
(function (DialogType) {
    /** Standard dialog */
    DialogType[DialogType["normal"] = 0] = "normal";
    /** Dialog with large header banner */
    DialogType[DialogType["largeHeader"] = 1] = "largeHeader";
    /** Dialog with an 'x' close button in the upper-right corner */
    DialogType[DialogType["close"] = 2] = "close";
})(exports.DialogType || (exports.DialogType = {}));
var DialogType = exports.DialogType;

//# sourceMappingURL=Dialog.Props.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./components/Dialog/Dialog.Props.js
 ** module id = 156
 ** module chunks = 0
 **/